import {
  dripMediumDescriptions,
  dripMediumNames,
  dripMediumOptions,
  dripMediumOptionsWithEmail,
  dripMediumOptionsWithText
} from 'features/CustomCampaigns/EditCampaign/CampaignSetup'

export const inviteMediumOptions = dripMediumOptions

export const inviteMediumNames = dripMediumNames

export const inviteMediumOptionsWithEmail = dripMediumOptionsWithEmail

export const inviteMediumOptionsWithText = dripMediumOptionsWithText

export const inviteMediumDropdownOptions = {
  [dripMediumOptions.Text]: dripMediumNames.Text,
  [dripMediumOptions.Email]: dripMediumNames.Email,
  [dripMediumOptions.EmailAndText]: dripMediumNames.EmailAndText,
  [dripMediumOptions.TextWithEmailFallback]: dripMediumNames.TextWithEmailFallback
}

export const inviteMediumLegendItems = [
  dripMediumOptions.Text,
  dripMediumOptions.Email,
  dripMediumOptions.EmailAndText,
  dripMediumOptions.TextWithEmailFallback
].map(medium => ({
  medium,
  label: dripMediumNames[medium],
  description: dripMediumDescriptions[medium]
}))

export const inviteMediumDescriptions = inviteMediumLegendItems.reduce((acc, item) => {
  acc[item.medium] = item.description
  return acc
}, {})
